import Typography from '@mui/material/Typography';
import { FC } from 'react';
import { useSiteTitle } from 'src/context/SiteTitleContext';

const ComingSoonPage: FC<any> = () => {
    const siteTitle = useSiteTitle();

    return (
        <>
            <Typography align='center' variant='h1'>{`${siteTitle.title}`}</Typography>
            <Typography align='center' variant='h3'>kommer snart!</Typography>
        </>
    )

}

export default ComingSoonPage;